import axios from "axios"
import { BaseUrl } from "../Config/config"
import { Headers } from "../Config/configheaders"

const Configheaders = () => {
    return {
        headers: Headers()
    }
}

export const LoginApi = (params) => {
    return axios.post(`${BaseUrl}/admin_login`, params);
}

export const GetUsersApi = (page, search) => {
    return axios.get(`${BaseUrl}/get_users?page=${page}&search=${search}`, Configheaders());
}

export const GetTimeZones = () => {
    return axios.get(`${BaseUrl}/available_timezones`, Configheaders());
}

export const SendNotification = (params) => {
    return axios.post(`${BaseUrl}/send_congratulations`, params, Configheaders());
}

export const ChangePasswordApi = (params) => {
    return axios.post(`${BaseUrl}/change_admin_password`, params, Configheaders());
}

export const UpdateEmailApi = (params) => {
    return axios.put(`${BaseUrl}/update_email`, params, Configheaders());
}

export const LogoutApi = () => {
    return axios.post(`${BaseUrl}/admin_logout`, Configheaders());
}
